import { Activity } from 'app/activity/models/activity.model';

export class AffinitiesActivity extends Activity {

  constructor(activity?: Activity) {
    super(activity);
  }

}
